import React from "react";
import { Form, Input } from "antd";

export const FormIteamFinance = ({ disabled = false }) => {
	return (
		<>
			<div className="w-full  flex flex-col gap-2">
				<p className="text-[12px] font-bold">Comentarios</p>
				<p className="text-[10px] text-[#9A9A9A]">Cualquier cosa que tenga que ver con estar al tanto de cuestiones de cobro/pago</p>
				<Form.Item
					name="finanzas"
					rules={[
						{
							required: true,
							message: "No puede ir vacio",
						},
					]}
				>
					<Input.TextArea
						placeholder="Comentario"
						autoSize={{
							minRows: 5,
							maxRows: 5,
						}}
						disabled={disabled}
					/>
				</Form.Item>
			</div>
		</>
	);
};
